import type { RangeSliderFilterConfig } from '@alltrails/denali/components/FilterBar';
import { avoidZeroWidthRange } from '../utils/avoidZeroWidthRange';
import useDraftValue from './useDraftValue';

type RangeSliderConfig = RangeSliderFilterConfig['rangeSlider'];

/**
 * Range-slider flavor of {@link useDraftValue}: keeps the value local while dragging (committing on release)
 * and sanitizes against zero-width ranges. Shared by the modal's RangeSliderFilterControl and the filter-bar
 * range-slider dropdown. Read `draft` to display the live value.
 */
export default function useRangeSliderDraft({ marks, onChange, onChangeEnd, value }: RangeSliderConfig) {
  return useDraftValue<[number, number]>(value, {
    onChange,
    onChangeEnd,
    sanitize: next => avoidZeroWidthRange(next, marks),
    areEqual: (a, b) => a[0] === b[0] && a[1] === b[1]
  });
}
